<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-row class="float-right mr-1">
        <v-btn width="150" 
          class="mr-3" 
          type="submit" 
          color="primary"
          outlined
          @click="
            $router.go(-1)
          "
          >
          {{$t('cancel')}}
        </v-btn>
        <v-btn 
          width="150" 
          @click="
            $router.go(-1)
          "
          color="primary">
          {{$t('submit')}}
        </v-btn>
      </v-row>
      <v-row class="mt-8">
        <v-col md="8">
          <vue-html2pdf
            :show-layout="true"
            :float-layout="false"
            :enable-download="enable_download"
            :preview-modal="true"
            :paginate-elements-by-width="1500"
            filename="orderDetails"
            :pdf-quality="2"
            pdf-format="a4"
            :pdf-content-width="3500"
            pdf-orientation="portrait"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf"
          >
            <section slot="pdf-content">
              <!-- <div class="page-title">
                <div>
                  <h2>
                    #{{
                      order.orderNumber ? order.orderNumber : "Not Specified"
                    }}
                  </h2>
                  <p>
                    #{{ order.farmNumber ? order.farmNumber : "Not Specified" }}
                  </p>
                </div>
              </div> -->
              <v-card class="pa-2 px-5" outlined>
                <v-row class="mt-5">
                  <v-col>
                    <v-card height="100%" width="100%" elevation="2" outlined>
                      <v-list-item>
                        <v-list-item-content> 
                          <div class="page-title">
                            <div>
                              <h2>
                                {{
                                  "#"+$t('organizationNtrInfo.orderID')
                                }}
                              </h2>
                              <p>
                                #{{ order.orderNumber ? order.orderNumber : $t('notSpecified') }}
                              </p>
                            </div>
                          </div>
                            <!-- <div class="mt-2">
                              <v-list-item-title class="font-size-bold text-h5 mb-1">
                                {{totalOrderCount}}
                              </v-list-item-title>
                              <v-list-item-subtitle>Orders</v-list-item-subtitle>
                            </div> --> 
                          <div class="farm-details mt-2">
                            <h4>
                              {{ order.farm.name ? order.farm.name : $t('organizationNtrInfo.nameOfTheFarm') }}
                            </h4>
                            <p>
                              {{ order.farm.houseNo }} {{ order.farm.street }}
                              {{ order.farm.cityName }} {{ order.farm.stateName }}
                              {{
                                order.farm.countryName
                                  ? order.farm.countryName
                                  : $t('organizationNtrInfo.loremIpsumHasBeenTheIndustrySStandardDummyText')
                              }}
                            </p>
                            <p>
                              <b> {{$t('phoneNo')}}: </b
                              ><span>{{
                                order.farm.ownerMobile
                                  ? order.farm.ownerMobile
                                  : "234567890"
                              }}</span>
                            </p>
                            <h4>{{$t('organizationNtrInfo.billedTo')}}</h4>
                            <p>
                              {{
                                order.address
                                  ? order.address
                                  : $t('organizationNtrInfo.loremIpsumHasBeenTheIndustrySStandardDummyText')
                              }}
                            </p>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-col>
                  <!-- <v-col>
                    <v-card width="100%" height="100%"  elevation="2" outlined>
                      <v-list-item>
                        <v-list-item-content>
                          <div class="page-title">
                            <div>
                              <h2>
                                {{
                                  "#"+$t('organizationNtrInfo.recipientID')
                                }}
                              </h2>
                              <p>
                                #{{ order.recipientId ? order.recipientId : $t('notSpecified') }}
                              </p>
                            </div>
                          </div>
                            !-- <div class="mt-2">
                              <v-list-item-title class="font-size-bold text-h5 mb-1">
                                {{totalOrderCount}}
                              </v-list-item-title>
                              <v-list-item-subtitle>Orders</v-list-item-subtitle>
                            </div> -- 
                          <div class="recipient-details">
                            <h4>{{$t('organizationNtrInfo.billedTo')}}</h4>
                            <p>
                              {{
                                order.address
                                  ? order.address
                                  : $t('organizationNtrInfo.loremIpsumHasBeenTheIndustrySStandardDummyText')
                              }}
                            </p>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-col> -->
                </v-row>
                <!-- <div class="farm-details mt-2">
                  <h4>
                    {{ order.farm.name ? order.farm.name : "Name of the farm" }}
                  </h4>
                  <p>
                    {{ order.farm.houseNo }} {{ order.farm.street }}
                    {{ order.farm.cityName }} {{ order.farm.stateName }}
                    {{
                      order.farm.countryName
                        ? order.farm.countryName
                        : "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a"
                    }}
                  </p>
                  <p>
                    <b> Phone No: </b
                    ><span>{{
                      order.farm.ownerMobile
                        ? order.farm.ownerMobile
                        : "234567890"
                    }}</span>
                  </p>
                </div>
                <div class="recipient-details">
                  <h4>Billed To</h4>
                  <p>
                    {{
                      order.address
                        ? order.address
                        : "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a"
                    }}
                  </p>
                </div> -->
                <div class="table-section mt-5 mb-2">
                  <v-data-table
                    v-model="selected"
              show-select
                    :headers="headers"
                    :items="items"
                    class="elevation-1"
                    :hide-default-footer="true"
                  >
                    <template v-if="items.length > 0" v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.productNumber">
                        <td>
                      <v-checkbox
                        multiple
                        v-model="selected"
                        :value="item"
                        style="margin: 0px; padding: 0px"
                        hide-details
                        v-on:click.stop=""
                      />
                    </td>
                          <td class="">{{ item.productNumber }}</td>
                          <td class="">{{ item.product.productCategory.name }}</td>
                          <td class="text-center">
                            {{ item.productQty }} {{ item.productQtyUom }}
                          </td>
                          <td class="text-center">
                            {{ item.totalPrice }} {{ item.currency }}
                          </td>
                          <td class="text-center">
                            {{ item.status }} 
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </div>
                  </v-card>
                <div class="nag-details mt-5">
                  <!-- <v-row>
                <v-col lg="4" md="4" sm="4" xs="6"> -->
                  <v-list style="background-color:#E5F8F1;border: 1px solid #00BD73;border-radius: 5px;">
                    <v-list-item>
                      <v-list-item-avatar rounded>
                        <v-img src="/img/logod.png"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <div class="d-flex justify-space-between">
                          <h4 class="font-weight-black mt-5">NAGRAC</h4>
                          <p class="mt-2 ml-5">
                            {{$t('organizationNtrInfo.loremIpsumHasBeenTheIndustrySStandardDummyText')}}
                          </p>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <!-- </v-col> -->
                  <!-- <v-col lg="8" md="4" sm="4" xs="6" class="mt-2">
                  <p>
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a
                  </p>
                </v-col> -->
                  <!-- </v-row> -->
                </div>
            </section>
          </vue-html2pdf>
        </v-col>
        <v-col md="4">
          <!-- <v-card>
            <v-toolbar>
              <v-toolbar-title>{{$t('organizationNtrInfo.orderStatus')}} </v-toolbar-title>
            </v-toolbar>
            <v-list-item>
              <v-list-item-content>
                <form @submit.prevent="addStatus">
                <div class="mt-2">
                  !-- <v-list-item-subtitle>{{
                    "Order Status"
                  }}</v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mb-1">
                    #{{ order.recipientId ? order.recipientId : "34567" }}
                  </v-list-item-title> --
                   <div class="form-group mt-5">
                    <label for="text" class="">{{$t('organizationNtrInfo.orderStatus')}}</label>
                    <v-select
                    class="mt-3"
                      :items="status"
                      :placeholder="$t('organizationNtrInfo.selectStatus')"
                      v-model="order.status"
                      outlined
                      dense
                    ></v-select>
                  </div>
                  <v-btn width="150" class="float-right" type="submit" color="primary">{{$t('save')}}</v-btn>
                </div>
                </form>
              </v-list-item-content>
            </v-list-item>
          </v-card> -->
          <v-card rounded="10">
            
            <v-toolbar elevation="0" color="#E5F8F1" class="white--text" outlined>
              <v-toolbar-title style="color: #00BD73">
              <v-row justify="space-between" align="center">
                <v-col cols="6"> {{$t('organizationNtrInfo.orderDetails')}} </v-col>
                <v-col cols="6" align-self="end">
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="exportToPDF"
                  >
                    <v-img src="/icons/download.svg"></v-img>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="printPDF"
                  >
                    <v-img src="/icons/print.svg"></v-img>
                  </v-btn>
                </v-col>
              </v-row>
              </v-toolbar-title>
            </v-toolbar>
                  <div ref="document">
            <v-list-item>
              <v-list-item-content>
                <div class="mt-2">
                  <v-list-item-subtitle>{{
                    $t('organizationNtrInfo.recipientID')
                  }}</v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mb-1">
                    #{{ order.recipientId ? order.recipientId : "34567" }}
                  </v-list-item-title>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="mt-2">
                  <v-list-item-subtitle>{{
                    $t('organizationNtrInfo.recepientName')
                  }}</v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mb-1">
                    {{ order.recipientName ? order.recipientName : $t('organizationNtrInfo.cadbury') }}
                  </v-list-item-title>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="mt-2">
                  <v-list-item-subtitle>{{
                    $t('organizationNtrInfo.totalAmount')
                  }}</v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mb-1">
                    {{ order.totalPrice ? order.totalPrice : "$49000.0" }}
                    {{ order.currency }}
                  </v-list-item-title>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="mt-2">
                  <v-list-item-subtitle>{{
                    $t('organizationNtrInfo.deliveryCharges')
                  }}</v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mb-1">
                    ${{ "49.0" }}
                  </v-list-item-title>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="mt-2">
                  <v-list-item-subtitle>{{ $t('tax') }}</v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mb-1">
                    {{ "$2000" }}
                  </v-list-item-title>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="mt-2">
                  <v-list-item-subtitle>{{
                    $t('organizationNtrInfo.deliveryOnTime')
                  }}</v-list-item-subtitle>
                  <v-list-item-title class="text-h6 mb-1">
                    {{ "12:29:33 GMT" }}
                  </v-list-item-title>
                </div>
              </v-list-item-content>
            </v-list-item>
          </div>
          </v-card>
        </v-col>
      </v-row>
      <div class="float-right mt-5 mb-5">
        <v-btn
          width="146"
          class="mr-2"
          outlined
          color="primary"
          @click="generateReport()"
          >{{$t('exportAsPDF')}}</v-btn
        >
        <v-btn width="146" type="submit" @click="print()" color="primary"
          >{{$t('print')}}</v-btn
        >
      </div>
    </v-container>
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import NtrService from "@/_services/NtrService";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    breadcrumb: Breadcrumb,
    VueHtml2pdf,
  },
  data() {
    return {
      order: {
        farm: {
          name: "",
        },
        status:""
      },
      enable_download: true,
      items: [],
      selected: [],
      status:["delivered","confirmed","pending"],
      headers: [
        {
          text: this.$t('organizationNtrInfo.productID'),
          align: "start",
          sortable: false,
          value: "productNumber",
        },
         {
          text: this.$t('farm.productCategory'),
          value: "productCategory",
          sortable: false,
          align: "",
        },
        {
          text: this.$t('organizationNtrInfo.quantity'),
          value: "productQty",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t('organizationNtrInfo.totalAmount'),
          value: "totalamt",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t('status'),
          value: "status",
          sortable: false,
          align: "center",
        },
      ],
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('organizationNTR'),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "ProductList" },
        },
         {
          text: this.$t('organizationNtrInfo.farmProducts'),
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: "FarmProducts",
            params: { farmId: this.$route.params.farmId },
          },
        },
        {
          text: this.$t('farm.products'),
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: "SingleProduct",
            params: {
              farmId: this.$route.params.farmId,
              productId: this.$route.params.productId,
            },
          },
        },
        // {
        //   text: "Single Product",
        //   disabled: false,
        //   link: true,
        //   exact: true,
        //   to: {
        //     name: "SingleProduct",
        //     params: {
        //       farmId: this.$route.params.farmId,
        //       productId: this.$route.params.productId,
        //     },
        //   },
        // },
        {
          text: `${this.$route.params.orderId}`,
          disabled: true,
          href: "#",
        },
      ],
    };
  },
  async mounted() {
    await this.getItem();
  },
  methods: {
    async getItem() {
      this.startLoading();
      NtrService.getOrderDetails(this.$route.params.orderId)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.order = res.data.order;
            this.items = [res.data.order];
            this.stopLoading();
          }
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
    exportToPDF() {
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: "OrderDetails.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    async printPDF() {
      let opt = {
        margin: 1,
        filename: "OrderDetails.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };
      console.log(this.$refs.document, 'first')
      let worker = await html2pdf()
        .set(opt)
        .from(this.$refs.document)
        .toCanvas()
        .outputPdf("blob", "OrderDetails.pdf");
      let file = new File([worker], "OrderDetails.pdf", {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    addStatus(){
      const data={
        orderNumber:this.order.orderNumber,
        status:this.order.status
      }
      NtrService.updateStatus(data).then((res) => {
        console.log(res);
        if (res.success==true) {
            this.$notify({
              title: this.$t('statusUpdated'),
              text: res.message,
              type: 'success'
            });
          }else{
            this.$notify({
              title: this.$t('statusNotUpdated'),
              text: res.message,
              type: 'error'
              });
          }
      })
       .catch((err) => {
          console.log(err);
          // this.stopLoading()
        });

    },
    //  download() {
    //   const doc = new jsPDF("l","pt");
    //   /** WITH CSS */
    //   var canvasElement = document.createElement("canvas");
    //   html2canvas(this.$refs.content, {canvas: canvasElement }).then( async function(
    //     canvas
    //   ) {
    //     // var img_w = canvas.width;
    //     // var img_h = canvas.height;
    //     // console.log("style",img_w)
    //     // console.log("style",img_h)
    //     const img = canvas.toDataURL("image/jpeg",0.8);
    //     await doc.addImage(img, "JPEG", 10, 10);
    //     doc.save("new.pdf");
    //   });
    // },
    setDownload() {
      this.enable_download = false;
      return this.enable_download;
    },
    async generateReport() {
      this.enable_download = true;
      //  await this.pdfwidth()
      this.$refs.html2Pdf.generatePdf();
    },
    async print() {
      await this.setDownload();
      this.$refs.html2Pdf.generatePdf();
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss">
.page-title p {
  color: $primary-color;
}
.farm-details {
  max-width: 270px;
  // margin-left: 20px;
}
.recipient-details {
  max-width: 270px;
  // margin-left: 20px;
  margin-top: 10px;
}
/* .tabs-section .v-application .primary--text {
	color: #6A7784 !important;
}  */

.v-data-table-header {
  background: $secondary2-color;
}
.v-data-table-header span {
  color: black;
  // text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.05em;
}
tbody {
  letter-spacing: 0.05em;
  font-size: 14px;
}
.vue-html2pdf {
  .layout-container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: -100vw;
    top: 10px;
    z-index: -9999;
    background: rgba(95, 95, 95, 0.8);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
    &.show-layout {
      left: 0vw;
      z-index: 9999;
    }
    &.unset-all {
      all: unset;
      width: auto;
      height: auto;
    }
  }
}
.pdf-content {
  width: 100%;
  background: #fff;
}
// .registration-btn.bottom-btn {
//   margin: 30px 22px 0px 0px;
//   justify-content: flex-end;
//   padding: 24px 15px;
//   border-top: 1px solid #dae1ec;
//   width: 100%;
// }
// .registration-btn {
//   display: flex;
//   align-items: center;
// }
</style>